export default __webpack_public_path__ + "static/media/MyTaskIconLight.5d608303.svg";